import { mapState } from 'vuex'
import { ROLE } from '@/lib/definitions'

export const corpMixins = {
  computed: {
    ...mapState(['user']),
    isCorpRole(this: any) {
      return this.user.role === ROLE.CORP_USER
    }
  },
}
